import { fork, takeEvery, call, select, put } from 'redux-saga/effects'

import { userSelector } from 'auth/selectors'
import { localeSelector } from '@i18n/selectors'
import { formatLocale } from 'shared/utils'
import { indicateProgress } from 'api'

import * as api from './api.js'
import * as constants from './constants.js'
import * as actions from './actions.js'
import { waitlistIdSelector } from './selectors.js'

export function* getWaitingListStateSaga() {
    yield takeEvery(constants.GET_WAITING_LIST_STATE, function* () {
        const { token } = yield select(userSelector)
        const waitingListId = yield select(waitlistIdSelector)

        const waitingListState = yield call(
            indicateProgress,
            [constants.GET_WAITING_LIST_STATE],
            api.getWaitingListState,
            waitingListId,
            token
        )

        waitingListState.message
            ? yield put(actions.failedWaitingListState(waitingListState.message))
            : yield put(actions.setWaitingListState(waitingListState))
    })
}

export function* subscribeWaitingListSaga() {
    yield takeEvery(constants.SUBSCRIBE_WAITING_LIST, function* () {
        const { token } = yield select(userSelector)
        const requestId = yield select(waitlistIdSelector)
        const locale = yield select(localeSelector)

        const result = yield call(
            indicateProgress,
            [constants.SUBSCRIBE_WAITING_LIST],
            api.subscribeWaitingList,
            formatLocale(locale),
            requestId,
            token
        )

        yield put(actions.setResultSubscribeWaitingList(result))
    })
}

export default function* rootSaga() {
    yield fork(getWaitingListStateSaga)
    yield fork(subscribeWaitingListSaga)
}
